/**
 * SheetClip - Spreadsheet Clipboard Parser
 * version 0.2
 *
 * This tiny library transforms JavaScript arrays to strings that are pasteable by LibreOffice, OpenOffice,
 * Google Docs and Microsoft Excel.
 *
 * Copyright 2012, Marcin Warpechowski
 * Licensed under the MIT license.
 * http://github.com/warpech/sheetclip/
 */
/*jslint white: true*/
// 用模块级变量接住 IIFE 的返回值，供文件末尾的 ES module 默认导出使用
// （原库把 SheetClip 定义在闭包内，外部无法直接引用）
var sheetClipInstance = (function (global) {
  "use strict";

  function countQuotes(str) {
    return str.split('"').length - 1;
  }

  var SheetClip = {
    /**
     * Decode spreadsheet string into array
     *
     * @param {String} str
     * @returns {Array}
     */
    parse: function (str) {
      var r, rLen, rows, arr = [], a = 0, c, cLen, multiline, last;

      rows = str.replace(/\r\n|\r/g, '\n').split('\n');

      if (rows.length > 1 && rows[rows.length - 1] === '') {
        rows.pop();
      }
      for (r = 0, rLen = rows.length; r < rLen; r += 1) {
        rows[r] = rows[r].split('\t');

        for (c = 0, cLen = rows[r].length; c < cLen; c += 1) {
          if (!arr[a]) {
            arr[a] = [];
          }
          if (multiline && c === 0) {
            last = arr[a].length - 1;
            arr[a][last] = arr[a][last] + '\n' + rows[r][0];

            if (multiline && (countQuotes(rows[r][0]) & 1)) { //& 1 is a bitwise way of performing mod 2
              multiline = false;
              arr[a][last] = arr[a][last].substring(0, arr[a][last].length - 1).replace(/""/g, '"');
            }
          }
          else {
            if (c === cLen - 1 && rows[r][c].indexOf('"') === 0 && (countQuotes(rows[r][c]) & 1)) {
              arr[a].push(rows[r][c].substring(1).replace(/""/g, '"'));
              multiline = true;
            }
            else {
              arr[a].push(rows[r][c].replace(/""/g, '"'));
              multiline = false;
            }
          }
        }
        if (!multiline) {
          a += 1;
        }
      }

      return arr;
    },

    /**
     * Encode array into valid spreadsheet string
     *
     * @param arr
     * @returns {String}
     */
    stringify: function (arr) {
      var r, rLen, c, cLen, str = '', val;

      for (r = 0, rLen = arr.length; r < rLen; r += 1) {
        cLen = arr[r].length;

        for (c = 0; c < cLen; c += 1) {
          if (c > 0) {
            str += '\t';
          }
          val = arr[r][c];

          if (typeof val === 'string') {
            if (val.indexOf('\n') > -1) {
              str += '"' + val.replace(/"/g, '""') + '"';
            }
            else {
              str += val;
            }
          }
          else if (val === null || val === void 0) { // void 0 resolves to undefined
            str += '';
          }
          else {
            str += val;
          }
        }

        if (r !== rLen - 1) {
          str += '\n';
        }
      }

      return str;
    }
  };

  // 仅挂到 global 作为兜底；不再赋值 exports.xxx：
  // 文件末尾有 `export` 语句，webpack 会判定本文件为 ES module，
  // 此时 exports/module.exports 为只读，赋值会直接抛错。
  global.SheetClip = SheetClip;

  // 交给下方的 ES module 导出使用
  return SheetClip;
}(window));

/*
 * ES module 默认导出。
 *
 * handsontable 内核按 ES module 引入本库：
 *   import SheetClip from './../lib/SheetClip/SheetClip';   // dataMap.js、plugins/copyPaste
 * 原库是 IIFE + CommonJS 写法，SheetClip 定义在闭包内部、外部无法直接引用，
 * webpack 按 ESM 解析时拿不到默认导出，SheetClip 会是 undefined，
 * 触发复制/粘贴或数据序列化时会抛 "Cannot read properties of undefined"。
 *
 * 这里让 IIFE 把内部对象 return 出来（见上方 return），
 * 用模块级变量接住后再默认导出，库自身实现逻辑未做任何改动。
 */
export default sheetClipInstance;
